
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { GetStaticProps } from 'next';
import { useState } from 'react';
import styled from 'styled-components';
import COMPANY_DATA from 'config/companyData';
import Email from 'shared/components/Email';
import MainHeading from 'shared/components/MainHeading';
import Page from 'shared/components/Page';
import Section from 'shared/components/Section';
import useTranslation from 'shared/hooks/useTranslation';
import Trans from 'next-translate/Trans';
const { COMPANY_NAME, COMPANY_STREET, COMPANY_ZIP_CODE, COMPANY_ASSETS, BOK_EMAIL, PHONE } = COMPANY_DATA;
const Wrapper = styled.div `
  font-size: 1.6rem;
  margin: 0 auto;
  max-width: ${({ theme }) => theme.BREAKPOINT.LG};
  padding: 0 16px;

  ${({ theme }) => theme.MEDIA.MD} {
    font-size: 1.8rem;
  }
`;
const ContactSection = styled(Section) ``;
function Contact(): JSX.Element {
    const { t } = useTranslation('contactPage');
    const [show, setShow] = useState(false);
    return (<Page withLatestReviews={false}>
      <Wrapper>
        <ContactSection>
          <MainHeading>{t('header')}</MainHeading>
          <p>
            <b>{COMPANY_NAME}</b>
          </p>
          <p>
            {COMPANY_STREET}, {COMPANY_ZIP_CODE}
          </p>
          <p>NIP: 8971854393</p>
          <p>REGON: 369980751</p>
          <p>KRS: 0000737597</p>
          <p>{t('contact.court')}</p>
          <p>
            <Trans i18nKey="contactPage:contact.shareCapital" values={{
            asset: COMPANY_ASSETS,
        }} fallback="contactPageEN:contact.shareCapital"/>
          </p>
          <p>
            {t('contact.mail')}: <Email email={BOK_EMAIL} setVisible={setShow} visible={show}/>
          </p>
          <p>
            {t('contact.phone')}: <a href={`tel: +48 ${PHONE}`}>+48 {PHONE}</a>
          </p>
        </ContactSection>
      </Wrapper>
    </Page>);
}
const getStaticProps: GetStaticProps = async () => ({ props: {} });
export default Contact;

    async function __Next_Translate__getStaticProps__196d3bd90cf__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/contact',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__196d3bd90cf__ as getStaticProps }
  